export const categories = [
  { slug: 'wanghong-fanche', name: '网红翻车', icon: 'ri-alert-line', description: '网红翻车现场实时追踪，第一时间爆料' },
  { slug: 'yule-bagua', name: '娱乐八卦', icon: 'ri-chat-smile-2-line', description: '娱乐圈最新八卦资讯' },
  { slug: 'heila-baoliao', name: '黑料爆料', icon: 'ri-fire-line', description: '独家黑料深度爆料' },
  { slug: 'jieri-dagua', name: '今日大瓜', icon: 'ri-fire-line', description: '每日新鲜大瓜汇总' },
  { slug: 'zhibo-fanche', name: '直播翻车', icon: 'ri-live-line', description: '主播直播翻车名场面' },
  { slug: 'shejiao-reshi', name: '社交热事', icon: 'ri-share-line', description: '社交媒体热门事件' },
];

export const articles = [
  {
    id: 1,
    slug: 'dingji-wanghong-zhibo-fanche-mingmianchang',
    title: '顶流网红直播带货翻车！300万在线观众目睹全程，品牌方紧急解约',
    excerpt: '昨晚某千万粉丝网红在直播间带货时发生严重翻车事件，产品当场出现质量问题，引发全网热议。据悉该网红已与品牌方紧急解约，损失或超千万。',
    content: `<p>昨晚8点，拥有超过2000万粉丝的顶流网红"小仙女"在其直播间进行双十一预售直播时，发生了一起堪称年度级别的翻车事件。</p>
<p>据现场观众描述，当时直播间在线人数高达300万。小仙女正在推销一款售价699元的美容仪产品，声称"使用一周就能看到明显效果"。然而当她在镜头前亲自演示时，产品突然冒出白烟并发出刺耳的噪音，吓得她当场花容失色。</p>
<p>"我当时以为是正常现象，结果越用越不对劲，"一位购买了该产品的粉丝在社交平台吐槽，"用了两次脸上就过敏了，这质量也太差了。"</p>
<p>事件发酵后，该美容仪品牌深夜发布声明，宣布与小仙女解除所有合作关系，并表示将对已售产品进行全额退款。据业内人士估算，小仙女此次翻车造成的直接和间接损失可能超过千万元。</p>
<p>这已经不是小仙女第一次出现翻车事件。今年3月，她曾因推荐的一款减肥产品被曝含有违禁成分而受到质疑。尽管当时她迅速道歉并下架了产品，但这次美容仪事件显然让她的信誉再次受到严重打击。</p>
<p>截至发稿前，小仙女的社交媒体账号评论区已经被愤怒的粉丝攻陷，相关话题在微博热搜榜持续占据前三位。不少网友表示："这就是所谓的良心推荐吗？""300万人面前翻车，这波操作我给满分。"</p>`,
    category: 'wanghong-fanche',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20female%20live%20streamer%20shocked%20expression%20in%20front%20of%20camera%20with%20smoke%20coming%20from%20product%2C%20dramatic%20studio%20lighting%2C%20modern%20streaming%20room%20background%2C%20editorial%20news%20style%20photography%2C%20high%20contrast%2C%20cinematic&width=1200&height=675&seq=chigua-article-01&orientation=landscape',
    author: '吃瓜小分队',
    publishedAt: '2026-07-06',
    readTime: '8分钟',
    viewCount: 1280000,
    tags: ['小仙女', '直播翻车', '美容仪', '品牌解约', '双十一'],
    isHot: true,
    isNew: true,
  },
  {
    id: 2,
    slug: 'mou-zhiming-yanyuan-hunwaiqing-baoguang',
    title: '独家爆料：知名男演员深夜密会神秘女子，婚内出轨实锤曝光',
    excerpt: '本报独家拍到某一线男演员深夜与神秘女子共进晚餐后同回酒店，全程亲密互动。该演员已婚多年，此次出轨实锤引发娱乐圈地震。',
    content: `<p>【吃瓜官网独家】近日，本报记者经过长达一个月的跟踪调查，独家拍到了知名男演员陈某（化名）与一名神秘女子约会的全过程。</p>
<p>据目击者称，7月5日晚11点左右，陈某独自驾车来到北京某高档餐厅，与一名身材高挑的年轻女子共进晚餐。两人在包厢内用餐约两小时后，于凌晨1点前后一同离开，随后乘坐同一辆保姆车前往朝阳区某五星级酒店。</p>
<p>记者拍到的画面显示，两人在酒店大堂等待办理入住时举止亲密，女子多次挽住陈某的手臂，陈某也时不时低头与女子耳语，神情暧昧。</p>
<p>值得注意的是，陈某与圈内知名女演员李某结婚已有8年，两人育有一子一女，一直以"模范夫妻"的形象示人。就在上个月，陈某还在某综艺节目中大谈"婚姻保鲜秘诀"，如今看来讽刺意味十足。</p>
<p>消息传出后，陈某的工作室至今未做出任何回应。而其妻子的社交媒体账号也在事发后设置为"仅自己可见"状态。</p>
<p>一位不愿透露姓名的圈内人士向本报透露："陈某和他妻子的婚姻早就名存实亡了，两人各玩各的已经不是秘密。只是没想到会以这种方式被曝光。"</p>
<p>目前，陈某代言的三个品牌已经紧急撤下了与其相关的所有宣传物料，业内预计其商业价值将遭受重创。</p>`,
    category: 'heila-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Blurred%20night%20scene%20of%20luxury%20hotel%20entrance%20with%20silhouettes%20of%20a%20man%20and%20woman%20walking%20together%2C%20paparazzi%20style%20photography%2C%20dramatic%20moody%20lighting%2C%20dark%20tones%2C%20mysterious%20atmosphere%2C%20urban%20night%20setting&width=1200&height=675&seq=chigua-article-02&orientation=landscape',
    author: '吃瓜小分队',
    publishedAt: '2026-07-06',
    readTime: '10分钟',
    viewCount: 2350000,
    tags: ['陈某', '婚内出轨', '独家爆料', '娱乐圈', '模范夫妻'],
    isHot: true,
    isNew: true,
  },
  {
    id: 3,
    slug: 'duanju-yijie-beihou-ziben-jiaoyi-neimu',
    title: '短剧一姐天价片酬曝光！单集报价800万，背后资本交易内幕惊人',
    excerpt: '近日有业内人士爆料，某短剧平台一姐的单集片酬高达800万元，远超一线影视明星。消息一出引发行业震动，背后涉及复杂的资本运作和流量博弈。',
    content: `<p>短剧行业的疯狂或许远超外界想象。近日，一份据称来自某头部短剧平台的内部报价单在圈内流传，上面赫然显示：该平台签约的"短剧一姐"王某，单集片酬报价高达800万元。</p>
<p>以一季12集计算，仅王某一人就能拿走近亿元片酬。而据业内人士透露，一部短剧的制作总成本通常在3000万到5000万之间。这意味着，王某一个人的片酬就足以制作两部短剧。</p>
<p>"这个数字确实离谱，但放在当下的短剧市场，也不是完全不可能。"一位短剧制片人向记者分析道，"短剧市场现在是典型的'流量为王'，谁能带来播放量，谁就有议价权。"</p>
<p>更为惊人的是，记者进一步调查发现，王某的片酬背后隐藏着更为复杂的资本交易。据悉，王某所在的MCN机构与投资方签订了对赌协议，片酬中的相当一部分实际上是通过复杂的股权结构进行支付的。</p>
<p>"这不仅仅是片酬的问题，而是一整套资本运作。"前述制片人表示，"相当于用投资人的钱来制造繁荣假象，然后再用这个假象去吸引下一轮融资。"</p>
<p>目前，国家广电总局已经注意到短剧行业的天价片酬问题，正在制定相关规范措施。有消息称，短剧演员片酬上限规定有望在今年年底前出台。</p>`,
    category: 'yule-bagua',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20film%20set%20with%20Chinese%20actress%20surrounded%20by%20production%20crew%20and%20cameras%2C%20dramatic%20spotlight%20effect%2C%20glamorous%20yet%20tense%20atmosphere%2C%20behind%20the%20scenes%20of%20short%20drama%20production%2C%20editorial%20photography&width=1200&height=675&seq=chigua-article-03&orientation=landscape',
    author: '吃瓜特派员',
    publishedAt: '2026-07-05',
    readTime: '7分钟',
    viewCount: 980000,
    tags: ['短剧', '天价片酬', '资本运作', 'MCN', '行业规范'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    slug: 'mou-zhibo-yijie-bei-zhi-shuju-zaojia',
    title: '直播一姐被指数据造假！后台真实数据曝光，水分高达70%',
    excerpt: '某第三方数据监测平台发布报告称，多位头部主播的直播间数据存在严重造假。其中最夸张的一位，真实观众数不到显示数据的30%。',
    content: `<p>直播带货行业的"皇帝的新衣"正在被一件件揭开。昨日，知名第三方数据监测平台"透明数据"发布了一份调查报告，直指多位头部主播的直播间数据存在严重造假。</p>
<p>报告显示，拥有3000万粉丝的"直播一姐"赵某，其直播间显示的在线人数长期维持在100万左右，但根据"透明数据"的多维度交叉验证，真实在线人数平均只有28万左右，水分高达72%。</p>
<p>"我们通过IP去重、互动率分析、弹幕密度等多个维度进行了综合测算，得出的结论是一致的。"透明数据CEO在接受采访时表示，"70%以上的水分在行业内其实已经是公开的秘密了。"</p>
<p>除了在线人数，直播间的GMV（成交总额）也被质疑存在注水。报告指出，部分主播在直播结束后会出现大量退单，退单率高达40%-60%，但主播对外公布的GMV数据并未剔除退单部分。</p>
<p>面对质疑，赵某的团队发布声明称"透明数据的监测方法不科学"，并表示将保留追究法律责任的权利。然而，多位曾被赵某直播间"割韭菜"的商家站出来现身说法，证实了数据造假的问题。</p>`,
    category: 'zhibo-fanche',
    image: 'https://readdy.ai/api/search-image?query=Dark%20computer%20screen%20showing%20manipulated%20data%20charts%20and%20graphs%20with%20red%20warning%20signals%2C%20modern%20office%20setting%2C%20tense%20investigative%20journalism%20style%2C%20dramatic%20lighting%20with%20shadows%2C%20conceptual%20data%20fraud%20theme&width=1200&height=675&seq=chigua-article-04&orientation=landscape',
    author: '数据打假队',
    publishedAt: '2026-07-05',
    readTime: '6分钟',
    viewCount: 1560000,
    tags: ['直播带货', '数据造假', '赵某', '透明数据', 'GMV'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    slug: 'duanju-nanzhu-jingwai-dubo-qianju',
    title: '短剧男神境外赌博欠下巨债，被追债人堵门视频流出',
    excerpt: '近期爆红的短剧男演员林某被曝沉迷境外赌博，累计欠下超过5000万元赌债。一段被追债人堵在酒店的视频在网上疯传。',
    content: `<p>人前光鲜亮丽的"短剧男神"，人后却深陷赌博泥潭。近日，一段据称是短剧顶流男演员林某被追债的视频在社交媒体上引发轩然大波。</p>
<p>视频显示，林某在澳门某酒店大堂被数名男子围堵，双方发生激烈争执。视频中可以清晰听到追债人喊道："五千万你打算拖到什么时候？再不还钱别怪我们不客气！"</p>
<p>据知情人士透露，林某在过去两年间频繁出入澳门和东南亚的赌场，不仅输光了自己的所有积蓄，还向高利贷借了大量赌资。目前累计欠款已经超过5000万元人民币。</p>
<p>"他拍短剧确实赚了不少钱，但根本不够他赌的。"一位与林某合作过的制片人表示，"有几次拍戏的时候他状态很差，我们当时还以为是工作太累，现在想想可能是通宵赌博没睡觉。"</p>
<p>事件曝光后，林某参演的三部待播短剧均被平台方暂停上线。其经纪公司发表声明称"正在核实相关情况"，但未对赌博欠债一事进行正面否认。</p>`,
    category: 'heila-baoliao',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20casino%20interior%20with%20dim%20dramatic%20lighting%2C%20poker%20chips%20scattered%20on%20green%20felt%20table%2C%20tense%20atmosphere%2C%20dark%20moody%20photography%20style%2C%20high%20stakes%20gambling%20theme%2C%20elegant%20but%20dangerous%20vibe&width=1200&height=675&seq=chigua-article-05&orientation=landscape',
    author: '吃瓜小分队',
    publishedAt: '2026-07-04',
    readTime: '6分钟',
    viewCount: 1890000,
    tags: ['短剧男神', '境外赌博', '巨额欠债', '林某', '视频流出'],
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    slug: 'liang-da-mcn-jigou-beihou-enyuan',
    title: '两大MCN机构撕破脸！互曝黑料揭行业潜规则，千万网红被卷入',
    excerpt: '国内两大头部MCN机构近日在社交平台公开互撕，互相爆料对方压榨主播、阴阳合同、偷税漏税等黑料，多位千万级网红被卷入其中。',
    content: `<p>一场MCN行业的大地震正在上演。日前，国内排名前两位的MCN机构"星耀传媒"和"鼎盛文化"突然在社交平台掀起了一场史无前例的公开互撕大战。</p>
<p>事情的起因是星耀传媒旗下一位拥有1500万粉丝的美妆博主突然宣布解约转投鼎盛文化。星耀传媒随即在官方账号发文，直指鼎盛文化"以不正当手段挖角"，并爆料鼎盛文化存在"阴阳合同"、"偷税漏税"等问题。</p>
<p>鼎盛文化不甘示弱，迅速回击称星耀传媒"压榨旗下主播"，"抽成比例高达80%"，"强迫主播签订长达十年的霸王合同"。更令人震惊的是，鼎盛文化还晒出了多张据称是星耀传媒内部的工作群聊天截图，内容涉及恶意抹黑竞争对手和刷量造假。</p>
<p>这场互撕很快将多位千万级网红卷入其中。一部分网红选择站队发声，另一部分则保持沉默观望。有业内人士分析，这场互撕的背后实际上是两家公司在争夺上市前的舆论优势。</p>
<p>"MCN行业的水比外界想象的要深得多。"一位不愿具名的MCN从业者表示，"阴阳合同、刷量、偷税这些确实存在，但这次被公开撕出来，对整个行业的影响可能是毁灭性的。"</p>`,
    category: 'shejiao-reshi',
    image: 'https://readdy.ai/api/search-image?query=Two%20business%20people%20in%20intense%20confrontation%20in%20modern%20office%2C%20dramatic%20split%20lighting%2C%20tension%20and%20conflict%2C%20corporate%20drama%20theme%2C%20editorial%20style%20photography%2C%20dark%20and%20light%20contrast&width=1200&height=675&seq=chigua-article-06&orientation=landscape',
    author: '吃瓜特派员',
    publishedAt: '2026-07-04',
    readTime: '9分钟',
    viewCount: 1100000,
    tags: ['MCN', '互撕', '阴阳合同', '偷税漏税', '行业潜规则'],
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    slug: 'mou-dingji-wanghong-shenxian-yanzhi-zhenxiang',
    title: '某顶流网红"神仙颜值"真相曝光：直播滤镜关闭后判若两人',
    excerpt: '近日一位以"神仙颜值"著称的网红在户外直播时意外关闭了美颜滤镜，真实面貌与平时判若两人，引发粉丝大规模脱粉。',
    content: `<p>滤镜时代的"照骗"又添新案例。7月3日，以"神仙颜值"走红的网红主播"甜心宝贝"在一次户外直播中，由于设备故障意外关闭了美颜滤镜，其真实面貌瞬间暴露在数万观众面前。</p>
<p>平时在直播间里，甜心宝贝以精致的五官、白皙的皮肤和完美的身材比例著称，拥有超过800万粉丝。然而滤镜关闭后的画面显示，她的皮肤存在明显的痘印和色斑，五官也与平时有较大出入。</p>
<p>尽管她在发现后迅速重新开启了滤镜并试图以"灯光问题"搪塞过去，但已经有不少观众截屏并在社交平台疯传。话题"甜心宝贝滤镜翻车"迅速登上热搜，当日阅读量超过3亿。</p>
<p>"我真的太失望了，关注了她两年，没想到全是假的。"一位已经取消关注的粉丝在评论区写道。据统计，事件发生后24小时内，甜心宝贝的粉丝数减少了近50万。</p>
<p>然而也有不少理性的声音指出："直播开美颜本来就是行业常态，把一个人的价值完全建立在外表上本身就有问题。"</p>
<p>甜心宝贝在事件后发布了一篇长文道歉，承认自己"过度依赖滤镜"，并表示以后会"做真实的自己"。但业内人士分析，这次的信任危机对她的商业价值将产生长期影响。</p>`,
    category: 'wanghong-fanche',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20beauty%20filter%20app%20interface%20with%20before%20and%20after%20comparison%2C%20split%20screen%20effect%2C%20modern%20social%20media%20concept%2C%20clean%20product%20photography%20style%2C%20digital%20beauty%20theme&width=1200&height=675&seq=chigua-article-07&orientation=landscape',
    author: '颜值打假办',
    publishedAt: '2026-07-03',
    readTime: '5分钟',
    viewCount: 3200000,
    tags: ['滤镜翻车', '甜心宝贝', '颜值', '脱粉', '美颜'],
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    slug: 'jieri-bagua-zonghui-jingxuan',
    title: '今日八卦总汇：三瓜齐爆！明星隐婚生子、网红偷税被查、综艺黑幕曝光',
    excerpt: '今日吃瓜资讯汇总：某女星被曝隐婚生子已三岁；三位头部网红被税务部门约谈；热门综艺被曝存在剧本操控和恶意剪辑。',
    content: `<p>今天的瓜田格外热闹，三颗大瓜几乎同时爆出，让吃瓜群众们应接不暇。</p>
<p><strong>瓜一：女星隐婚生子已三岁</strong></p>
<p>据知情人士爆料，某位以"单身人设"圈粉无数的85后女星，其实早在三年前就已经秘密结婚并育有一子。该女星在社交媒体上长期营造"独立女性"形象，但事实上其丈夫是某知名互联网公司高管，孩子一直在国外由保姆照顾。目前该女星的经纪团队尚未回应。</p>
<p><strong>瓜二：三位头部网红被税务部门约谈</strong></p>
<p>继去年的网红补税风波后，税务部门再次出手。据悉，三位年收入过亿的头部主播近日被税务部门约谈，涉及通过虚假合同、拆分收入等方式偷逃个人所得税。业内人士称，此次约谈是一个信号，全网主播的税务合规风暴即将来临。</p>
<p><strong>瓜三：热门综艺被曝存在剧本操控</strong></p>
<p>一位曾参与某热门恋综录制的素人嘉宾日前发长文爆料，称节目组存在严重的剧本操控和恶意剪辑。"我们所有的互动都是被安排好的，连'心动'的瞬间都是排练过的。"该嘉宾还透露，节目组会刻意制造冲突来博取收视率，甚至不惜伤害嘉宾的隐私和声誉。</p>`,
    category: 'jieri-dagua',
    image: 'https://readdy.ai/api/search-image?query=Three%20watermelon%20slices%20arranged%20artistically%20on%20newspaper%20background%20with%20Chinese%20text%2C%20creative%20concept%20photography%2C%20bright%20red%20and%20green%20contrast%2C%20clean%20minimal%20composition%2C%20playful%20editorial%20style&width=1200&height=675&seq=chigua-article-08&orientation=landscape',
    author: '吃瓜日报',
    publishedAt: '2026-07-07',
    readTime: '7分钟',
    viewCount: 4500000,
    tags: ['隐婚生子', '偷税', '综艺黑幕', '今日八卦', '补税'],
    isHot: true,
    isNew: true,
  },
];

export const hotTags = [
  '小仙女翻车',
  '直播带货',
  '滤镜造假',
  'MCN互撕',
  '隐婚生子',
  '天价片酬',
  '数据造假',
  '偷税漏税',
  '综艺剧本',
  '网红赌博',
];

export const siteInfo = {
  name: '吃瓜官网',
  slogan: '全网最全吃瓜入口，每日新鲜大瓜等你来吃',
  description: '吃瓜官网作为全网核心吃瓜入口，覆盖51吃瓜官网全网最新、黑料吃瓜官网等热门站点，每日推送独家大瓜与网红翻车现场实时追踪，免费提供吃瓜资源。',
  email: 'contact@chigua.example.com',
  founded: '2024',
  socialLinks: {
    weibo: 'https://weibo.com/chigua',
    wechat: 'chigua_official',
    douyin: '@chigua',
  },
};